import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

const PointModal = ({ isOpen, toggle, mode = "create", pointData = null }) => {
  const [loading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    toggle();
  };

  const getModalTitle = () => {
    switch (mode) {
      case "create":
        return "Create New Point";
      case "edit":
        return "Edit Point";
      case "view":
        return "Point Details";
      default:
        return "Point";
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{getModalTitle()}</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {mode === "view" && pointData && (
            <>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>ID</Label>
                    <Input type="text" value={pointData.id || "-"} disabled />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Point ID</Label>
                    <Input type="text" value={pointData.pointId || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Display Name</Label>
                    <Input type="text" value={pointData.pointDisplayName || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Project ID</Label>
                    <Input type="text" value={pointData.projId || "-"} disabled />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Kind</Label>
                    <Input type="text" value={pointData.kind || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Current Value</Label>
                    <Input
                      type="text"
                      value={
                        pointData.curVal === null
                          ? "-"
                          : typeof pointData.curVal === "object" && pointData.curVal._kind === "number"
                          ? `${pointData.curVal.val} ${pointData.curVal.unit || ""}`
                          : pointData.curVal
                      }
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Current Status</Label>
                    <Input type="text" value={pointData.curStatus || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Unit</Label>
                    <Input type="text" value={pointData.unit || "-"} disabled />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Writable</Label>
                    <Input type="text" value={pointData.writable ? "Yes" : "No"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              {pointData.sourceModified && (
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label>Source Modified</Label>
                      <Input
                        type="text"
                        value={new Date(pointData.sourceModified).toLocaleString()}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label>Source Timezone</Label>
                      <Input type="text" value={pointData.sourceModifiedTimezone || "-"} disabled />
                    </FormGroup>
                  </Col>
                </Row>
              )}
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Created At</Label>
                    <Input
                      type="text"
                      value={new Date(pointData.createdAt).toLocaleString()}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Updated At</Label>
                    <Input
                      type="text"
                      value={new Date(pointData.updatedAt).toLocaleString()}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="3">
                  <FormGroup>
                    <Label>Sensor</Label>
                    <Input type="text" value={pointData.sensor ? "Yes" : "No"} disabled />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Point</Label>
                    <Input type="text" value={pointData.point ? "Yes" : "No"} disabled />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Cur</Label>
                    <Input type="text" value={pointData.cur ? "Yes" : "No"} disabled />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Aux</Label>
                    <Input type="text" value={pointData.aux ? "Yes" : "No"} disabled />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          {mode === "view" ? (
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          ) : (
            <>
              <Button color="secondary" onClick={toggle} disabled={loading}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    {mode === "create" ? "Creating..." : "Updating..."}
                  </>
                ) : mode === "create" ? (
                  "Create Point"
                ) : (
                  "Update Point"
                )}
              </Button>
            </>
          )}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default PointModal;
